/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */



import React, { useState, useImperativeHandle, useEffect, useRef } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../../../assets/styles/customStyles";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { checkComponentPermission, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import { CustomerListTable } from './CustomerListTable';
import usePrevious from "../../../../Shared/components/Previous";
import { CustomModal } from "../../../../Shared/components/DeleteModal";


export const CustomerList = React.forwardRef((props, ref) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { handleClose, handlePublishConfirm, form, type, loader } = props;

    const classes = customStyles();
    const dispatch = useDispatch();
    const [iconAnimation, setIconAnimation] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [publishModal, setPublishModal] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [selected, setSelected] = useState([]);
    const [skip, setSkip] = useState(0);
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const limit = 250;


    const dispatchFilter = (search = '', sortBy = 'id', sortOrder = 'desc', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { "and": [{ customerBusinessId: { neq: null } }, { customerBusinessId: { neq: 0 } }] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (form?.customerId) {
            filter['and'].push({ id: form.customerId });
        }

        if (form?.groupId) {
            filter['and'].push({ groupId: form.groupId });
        }


        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'customerProfile',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useImperativeHandle(ref, () => ({
        dispatchFilter() {
            dispatchFilter();
        }
    }))

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(search, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(search, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(search, sortBy, sortOrder);
    }

    useImperativeHandle(ref, () => ({
        dispatchFilter() {
            dispatchFilter();
        }
    }))

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(search, sortBy, sortOrder, s);
    }

    const handlePublish = () => {
        setPublishModal(true)
    }

    return <>
        <MainHeader {...props} img={SettingsImg} handleCloseClick={() => handleClose('price')}
            title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Batch Process', 'link': '' }]} />
        <div className={clsx(classes.margin40, classes.listTableMargin)}>
            <PrimaryCard
                title={'Customer List'}
                component={
                    <>
                        <Row align="middle" className={classes.marginBottom20}>
                            <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                {
                                    roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Action', 'Customer Search') &&
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder='Search'
                                            type='search'
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image
                                            src={SearchIcon}
                                            preview={false}
                                        />
                                    </div>
                                }
                            </Col>
                            <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                <div className={classes.overlFlowResponsiveDesign}>
                                    <Space direction="horizontal" align="center">
                                        <NavLink
                                            to={'#'}
                                            onClick={() => handleClose('price')}
                                            className={clsx(classes.AddMoreBtn)}>
                                            {`Back`}
                                        </NavLink>
                                        <NavLink
                                            to={'#'}
                                            onClick={() => setSelected([])}
                                            className={clsx(classes.AddMoreBtn, { [classes.disabled]: selected.length === 0 })}>
                                            {`Unselect ${selected.length > 0 ? '(' + selected.length + ')' : ''}`}
                                        </NavLink>

                                        {
                                            selected?.length > 0 && <>
                                                {
                                                    roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Action', 'Save') &&
                                                    <NavLink
                                                        to={'#'}
                                                        onClick={() => handlePublishConfirm(getList.filter((el) => { return selected.find(e => e === el.id) }), 'CREATED')}
                                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: loader })}>
                                                        Save
                                                    </NavLink>
                                                }
                                                {
                                                    roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Action', 'Publish') &&
                                                    <NavLink
                                                        to={'#'}
                                                        onClick={() => handlePublish()}
                                                        className={clsx(classes.modalBtn, { [classes.disabled]: selected.length === 0 })}>
                                                        Publish
                                                    </NavLink>
                                                }
                                            </>
                                        }
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                        <CustomerListTable
                            loadTasks={() => dispatchFilter(search, sortBy, sortOrder)}
                            details={getList}
                            loadMore={loadMore}
                            loadMoreTask={() => loadMoreTask()}
                            loadMoreContent={loadMoreContent}
                            sortOrder={sortOrder}
                            sortBy={sortBy}
                            roleManagement={roleManagement}
                            selected={selected}
                            handleSelected={(value) => setSelected(value)}
                            onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                        />
                    </>
                }
            />
        </div>
        <CustomModal
            onClose={(v) => setPublishModal(v)}
            yesButton={'Yes'}
            noButton={'Cancel'}
            title={'Publish Confirmation'}
            loading={loader}
            visible={publishModal} onOpen={() => handlePublishConfirm(getList.filter((el) => { return selected.find(e => e === el.id) }))}
            text={
                <>
                    <p>You have chosen to <span className={classes.bold}>Publish the Price list</span> to the following Customers. This action cannot be Reversed. Do you want to continue?</p>
                    <div className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink',)}>Selected Customer List</div>
                    <Row className={clsx(classes.margin10t)} style={{ maxHeight: 110, overflow: "auto" }}>
                        {
                            getList && getList?.length > 0 && getList.filter((el) => { return selected.find(e => e === el.id) })?.map((data, i) => (
                                <Col span={12}>{data.name}</Col>
                            ))
                        }
                    </Row>
                </>
            }
        />
    </>
})